import React from 'react';
import { useSelector } from 'react-redux';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { SecondaryOfferList } from 'components/OfferList/SecondaryOfferList';
import { useOfferContainer } from 'hooks/useOfferContainer';
import { getAccommodationPageHotelId, getHasActiveRoomFilter, getIsRoomsFiltersLoading } from 'modules/accommodation/selectors';
import { getAnchorPriceNightlyPerRoom, getSearchParameters } from 'modules/sapiSearch/selectors';
import { HotelOfferEntity } from 'modules/sapiSearch/slice';
import { getIsFilteredRoomsResultEmpty } from 'modules/searchApi/selectors';
import { RootState } from 'store';
import { Card } from '@daedalus/atlas/Card';
import { Divider } from '@daedalus/atlas/Divider';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
import { BOFH_PROXY_PROVIDER_CODE } from '@daedalus/core/src/offer/business/isBofhOffer';
import { PrimaryRoomOffer } from '../PrimaryRoomOffer';
import { PrimaryRoomOfferLoading } from '../PrimaryRoomOffer/PrimaryRoomOfferLoading';
import { AccommodationOfferBoxSoldout } from './AccommodationOfferBoxSoldout';
const OFFER_BOX_DATA_ID = 'offerBox';
const Wrapper = /*#__PURE__*/styled('section')({
  name: "Wrapper",
  class: "wo9u6vt",
  propsAsIs: false
});
interface MainProps {
  offerEntity?: HotelOfferEntity;
  isLoading?: boolean;
  primaryOfferRef?: React.Ref<HTMLElement>;
  selectedVioOfferId?: string;
}
const component = 'DesktopHotelViewTopOffers';
const OfferBoxComponent: React.FC<MainProps> = ({
  offerEntity,
  isLoading = false,
  primaryOfferRef,
  selectedVioOfferId
}) => {
  const hotelId = useSelector(getAccommodationPageHotelId);
  const anchorPrice = useSelector((state: RootState) => getAnchorPriceNightlyPerRoom(state, offerEntity));
  const {
    topOffers,
    anchorPriceTotal
  } = useOfferContainer({
    offerEntity,
    hotelId,
    offerId: selectedVioOfferId
  });
  const secondaryOffers = topOffers.filter(offer => offer.intermediaryProvider !== BOFH_PROXY_PROVIDER_CODE).slice(0, 2);
  const {
    checkIn,
    checkOut
  } = useSelector(getSearchParameters) || {};
  const hasActiveFilters = useSelector(getHasActiveRoomFilter);
  const hasNoRooms = useSelector(getIsFilteredRoomsResultEmpty);
  const isRoomsFiltersLoading = useSelector(getIsRoomsFiltersLoading);
  if (isLoading || isRoomsFiltersLoading) return <Wrapper data-id={OFFER_BOX_DATA_ID} className="__border">
        <Wrapper data-id="loader" ref={primaryOfferRef} className="__padding __primary __border">
          <PrimaryRoomOfferLoading />
        </Wrapper>
        {Array(2).fill(0).map((_, index) => <>
              {index > 0 && <Divider sideMargin="s500" />}
              <ContentWrapper padding="s500">
                <Flex.Row justifyContent="space-between" alignItems="center">
                  <div>
                    <SkeletonLoader height={18} width={118} />
                    <SkeletonLoader height={18} width={161} />
                    <SkeletonLoader height={18} width={118} />
                  </div>
                  <SkeletonLoader height={28} width={97} />
                </Flex.Row>
              </ContentWrapper>
            </>)}
      </Wrapper>;
  if (!secondaryOffers.length && hasNoRooms) {
    return <Card borderColorPath="border.neutral.c100" borderRadius="lg" dataId={OFFER_BOX_DATA_ID}>
        <AccommodationOfferBoxSoldout checkIn={checkIn} checkOut={checkOut} hasActiveFilters={hasActiveFilters} />
      </Card>;
  }
  return <Wrapper className={!!topOffers.length && '__border'} data-id={OFFER_BOX_DATA_ID}>
      <Wrapper ref={primaryOfferRef} className={cx(!hasNoRooms && '__border', '__primary', !hasNoRooms && '__padding')}>
        {!hasNoRooms ? <PrimaryRoomOffer hotelId={hotelId} component={component} /> : <AccommodationOfferBoxSoldout checkIn={checkIn} checkOut={checkOut} hasOtherOffers hasActiveFilters={hasActiveFilters} />}
      </Wrapper>
      <Wrapper className={cx(hasNoRooms && '__border', hasNoRooms && '__primary')}>
        <SecondaryOfferList variant="vertical" anchorPrice={anchorPrice} anchorPriceTotal={anchorPriceTotal} hotelId={hotelId} secondaryOffers={secondaryOffers} sourceComponent={component} showPriceIndication />
      </Wrapper>
    </Wrapper>;
};
export const AccommodationOfferBox = React.memo(OfferBoxComponent);

require("./AccommodationOfferBox.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AccommodationOfferBox.tsx");